import styled from 'styled-components';
import { device } from '../../../Config/device';

import Icon from '../../../Components/Icon';
import Input from '../../../Components/Form/Input';
import InputLabelSideBySide from '../../../Components/Form/InputLabelSideBySide';

export const AddEmployeeContainer = styled.div`
    align-items: center;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    grid-gap: 10px;
`;

export const AddEmployeeContainer_DHC = styled.div`
    flex: 1;
`;

export const AddEmployeeContainer_Employee = styled.div`
    align-items: center;
    display: flex;
    flex: 1;
    flex-direction: row;
    justify-content: flex-start;
`;

export const AddEmployeesContainer = styled.div`
    display: flex;
    flex-direction: column;
    grid-gap: 10px;
    justify-content: stretch;
`;

export const BodyContainer = styled.div`
    grid-area: body;
    padding: 15px 30px;
`;

export const BodyHeader = styled.div`
    align-items: center;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    width: 100%;

    @media ${device.maxwidth.ipad} {
        align-items: flex-start;
        flex-direction: column;
    }
`;

export const BodyHeaderRight = styled.div`
    align-items: center;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;

    @media ${device.minwidth.laptop} {
        margin-left: 10px;
    }
`;

export const DHCDetailModalInfoContainer = styled.div`
    align-items: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
`;

export const DHCDetailModalInfoFlexContainer = styled.div`
    align-items: center;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
`;

export const FilterContainer = styled.div`
    flex: 1;
`;

export const FilterHeaderContainer = styled.div`
    display: flex;
    position: relative;
    width: 100%;
`;

export const FiltersContainer = styled.div`
    border-left: 2px solid var(--white-concrete);
    grid-area: filter;
    padding: 15px 30px;
`;

export const FiltersSubContainer = styled.div`
    display: flex;
    flex-direction: column;
    grid-gap: 20px;
    justify-content: space-between;
`;

export const InsertEditModalContainer = styled.div``;

export const InvoiceContainer = styled.div`
    align-items: center;
    display: flex;
    flex-direction: row;
    flex: 1;
    justify-content: space-between;
    width: 100%;
`;

export const InvoiceDataContainer = styled.div``;

export const InvoicesContainer = styled.div`
    align-items: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
`;

export const MainContainer = styled.div`
    border-radius: 10px;
    display: grid;

    ${
        props => !props.ShowCustomizeFilters ?
        `
            @media ${device.minwidth.laptop} {
                grid-template-areas: "header filter"
                                    "body filter";
                grid-template-columns: 1fr 300px;
            }

            @media ${device.maxwidth.ipad} {
                grid-template-areas: "header" "body";
                grid-template-columns: 1fr;
            }
        `
    :
        `
            grid-template-areas: "header" "body";
            grid-template-columns: 1fr;
        `
    }

    grid-template-rows: 53px 1fr;
    overflow: hidden;
    width: 100%;
`;

export const MaxPercentInfoIcon = styled(Icon)`
    height: 20px;
    width: 20px;

    @media (min-width: 901px) {
        position: absolute;
        right: 10px;
        top: 0px;
    }
`;

export const OrderContainer = styled.div`
    background-color: var(--white-concrete);
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 10px 15px;
    width: 100%;
`;

export const OrderContainerBody = styled.div``;

export const OrderContainerBodyInvoiceContainer = styled.div`
    align-items: center;
    background-color: var(--white-concrete-hover);
    border-left: 15px solid var(--${props => props.BorderColor || 'white-concrete-hover'});
    border-radius: 10px;
    padding: 10px 15px;
    width: 100%;
`;

export const OrderContainerBodyInvoiceContainerMain = styled.div`
    align-items: center;
    display: grid;
    grid-gap: 10px;
    grid-template-columns: 1fr 3fr 3fr 5fr 3fr 4fr 3fr;
    width: 100%;
`;

export const OrderContainerBodyInvoiceContainerHeader = styled.div`
    align-items: center;
    border-left: 15px solid var(--white-concrete);
    display: grid;
    grid-gap: 10px;
    grid-template-columns: 1fr 3fr 3fr 5fr 3fr 4fr 3fr;
    margin-bottom: -10px;
    padding: 10px 15px;
    width: 100%;
`;

export const OrderContainerBodyInvoicesContainer = styled.div`
    align-items: center;
    display: flex;
    flex-direction: column;
    grid-gap: 10px;
    width: 100%;
`;

export const OrderContainerHeader = styled.div`
    align-items: center;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    width: 100%;

    @media(hover:hover) {
        :hover {
            cursor: pointer;
        }
    }
`;

export const OrderContainerHeaderLeft = styled.div``;

export const OrderContainerHeaderRight = styled.div`
    align-items: center;
    display: flex;
    flex-direction: row;
    grid-gap: 10px;
    justify-content: flex-end;
`;

export const OrdersContainer = styled.div`
    align-items: center;
    display: flex;
    grid-gap: 15px;
    flex-direction: column;
    justify-content: center;
`;

export const OrderStatusContainer = styled.div`
    align-items: center;
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    grid-gap: 5px;

    > svg {
        fill: var(--${props => props.FillColor});
    }
`;

export const PopoverContent = styled.div`
    align-items: center;
    background-color: var(--white);
    border-radius: 10px;
    box-shadow: 0px 3px 6px #00000029;
    display: flex;
    flex-direction: column;
    justify-content: center;
    max-width: 200px;
    padding: 10px;
`;

export const ProfilePhotoContainer = styled.div`
    margin-right: 5px;
    width: var(--profilephoto-size-small-3);
`;

export const ProfilePhotoContainer_Popup = styled.div`
    margin-right: 5px;
    width: var(--profilephoto-size-extra-large);
`;

export const SearchInput = styled(Input)`
    margin-right: 10px;

    > input {
        border-radius: 10px;
    }
`;

export const SearchUsersInput = styled(Input)`
    margin-right: 10px;
    max-width: 100%;

    @media ${device.maxwidth.mobile} {
        width: 170px;
    }

    @media ${device.minwidth.mobile} {
        width: 260px;
    }

    @media ${device.minwidth.ipad} {
        width: 320px;
    }

    > input {
        border-radius: 10px;
    }
`;

export const StyledHR = styled.div`
    background-color: var(--black);
    border-radius: 10px;
    height: 2px;
    margin: 20px 0px;
    width: 100%;
`;

export const StyledAmountInput = styled(InputLabelSideBySide)`
    width: 130px;

    > input {
        ${props => props.ReadOnly && 'border: none;'}
        border-radius: 10px;
        height: 100%;
        overflow: hidden;
        padding: 10px 15px;
        text-align: ${props => props.TextAlign ? props.TextAlign : 'center'};
        text-indent: 0px;
    }
`;

export const SortingIcon = styled(Icon)`
    width: 15px;
`;

export const ToggleIcon = styled(Icon)`
    > img {
        height: 10px;
    }
`;

export const UsersTableContainer = styled.div`
    overflow: scroll;
    max-height: 800px;
`;

export const UsersTable = styled.table`
    border: 1px solid var(--black);
    position: relative;
`;

export const UsersTableBody = styled.tbody`
    tr:nth-child(even) { background: #CCC; }
    tr:nth-child(odd) { background: #FFF; }
`;

export const UsersTableBodyRow = styled.tr`
    @media(hover:hover) {
        :hover {
            background-color: var(--abel-blue-hover) !important;
            color: var(--white) !important;
            cursor: pointer;
        }
    }
`;

export const UsersTableBodyCell = styled.td`
    padding: 5px 7px;
    white-space: nowrap;

    ${
        props => props.Flex &&
        `
            align-items: center;
            display: flex;
            flex-direction: row;
        `
    }
`;

export const UsersTableBodyCellFlexed = styled.div`
    align-items: center;
    display: flex;
    flex-direction: row;
`;

export const UsersTableHeader = styled.thead``;

export const UsersTableHeaderRow = styled.tr``;

export const UsersTableHeaderCell = styled.th`
    background-color: #CCC;
    font-family: var(--font-family-semibold);
    padding: 5px 7px;
    position: sticky;
    top: 0;
    z-index: 99;

    white-space: nowrap;
    overflow-y: scroll;
    height: 35px;
    text-align: left;

    ${
        props => !!props.onClick &&
        `
            @media(hover:hover) {
                :hover {
                    cursor: pointer;
                }
            }
        `
    }
`;

export const UsersTableHeaderCellInnerDiv = styled.div`
    align-items: center;
    display: flex;
    flex-direction: row;
    gap: 5px;
    justify-content: space-between;
`;